import { Component, ElementRef, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
import { WelcomeResource } from 'app/models/WelcomeResource';
import { UtilsService } from 'app/services/utils.service';
import { forkJoin } from 'rxjs';
import { KioskListResource } from 'app/models/KioskListResource';
import { FilterCriteriaListEdt } from 'app/models/FilterCriteriaListEdt';
import { KioskResource } from 'app/models/KioskResource';
import { FilterCriteriaEDT } from 'app/models/FilterCriteriaEDT';
import { WelcomeAndKioskResource } from 'app/models/WelcomeAndKioskResource';

@Component({
  selector: 'vbn-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit {

  selected_language: string;
  welcome: WelcomeResource;
  errorMessage: any;
  userEmail: string;
  dateNow = new Date();
  validationForm: FormGroup;

  kiosksList: KioskListResource;
  filterCriteria: FilterCriteriaListEdt;
  checkList: any;
  checkObject: any;
  kioskListResource: KioskResource[];
  arrayToSend: any;
  addressParams: any;
  saveErrors: boolean = false;
  welcomeRid:any;

  constructor(private fb: FormBuilder,
    private service: UtilsService,
    private element: ElementRef,
    private _notificationService: NotificationsService,
    private translate: TranslateService,
    private router: Router,
    private activatedRoute: ActivatedRoute) {
    this.selected_language = "ro";
    this.welcome = new WelcomeResource();
    this.kiosksList = new KioskListResource();
    this.kiosksList.list = new Array<KioskResource>();
    this.filterCriteria = new FilterCriteriaListEdt();
    this.filterCriteria.filters = new Array<FilterCriteriaEDT>();
    this.checkList = new Array();
    this.kioskListResource = new Array<KioskResource>();
    this.arrayToSend = new Array();
  }

  ngOnInit() {
    this.userEmail = this.service.currentUserEmail;
    this.getKioskList();
    if (this.router.url != '/add-welcome') {
      this.activatedRoute.params.subscribe((params: Params) => {
        if ('json' in params) {
          this.addressParams = JSON.parse(atob(params['json']));
          this.welcomeRid = this.addressParams.welcomeRid;
        }
      });
    }

    // this.getWelcomeSection();
    this.validationForm = this.fb.group({
      titleRo: ['', [Validators.required, Validators.maxLength(200), Validators.minLength(3), this.service.NoWhitespaceValidator()]],
      titleEn: [''],
      titleFr: [''],
      titleDe: [''],
      descriptionRo: ['', [Validators.required, Validators.minLength(3), this.service.NoWhitespaceValidator()]],
      descriptionEn: [''],
      descriptionFr: [''],
      descriptionDe: [''],
    })
  }

  getKioskList() {
    this.service.add('/admin/kiosk/getAll?userEmail=' + this.userEmail, this.filterCriteria)
      .subscribe(
        response => {
          this.kiosksList = response;
          if (this.kiosksList.errorCode == 1002) {
            forkJoin(
              [this.translate.get('Error'),
              this.translate.get('0 items found after the search!')]
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'error')
            });
            this.kiosksList = new KioskListResource();
            this.filterCriteria.filters = new Array<FilterCriteriaEDT>();
            this.kiosksList.list = [];
          }
          this.initializationKioskList();
          if (this.welcomeRid) {
            this.getWelcomeSection(this.welcomeRid);
          }
        },
        error => this.errorMessage = <any>error);
  }
  initializationKioskList() {
    if (this.kiosksList.list == null) {
      this.kioskListResource = []
    } else {
      this.kioskListResource = this.kiosksList.list;
    }
    this.checkList = new Array();
    for (let i = 0; i < this.kiosksList.list.length; i++) {
      this.checkObject = {};
      this.checkObject.kiosk = new WelcomeAndKioskResource();
      this.checkObject.kiosk = this.kiosksList.list[i];
      this.checkList.push(this.checkObject);
    }
    this.checkObject = {};
  }

  updateCheckedOptionsKiosk(kiosk, event) {
    if (event.target.checked) {
      let termsOrGdpr = new WelcomeAndKioskResource()
      termsOrGdpr.kiosk = kiosk;
      this.arrayToSend.push(termsOrGdpr);
    } else {
      for (let i = 0; i < this.arrayToSend.length; i++) {
        if (kiosk.rid == this.arrayToSend[i].kiosk.rid) {
          this.arrayToSend.splice(i, 1);
          return
        }
      }
    }
  }

  getWelcomeSection(rid) {
    this.service.get(`admin/welcome/getById?userEmail=${this.userEmail}&id=${rid}`)
      .subscribe(
        response => {
          this.welcome = response;
          Object.assign(this.kioskListResource, this.kiosksList)
          if (this.kioskListResource.length > 0) {
            for (let i = 0; i < this.kioskListResource.length; i++) {
              for (let j = 0; j < this.welcome.kioskResourceList.length; j++) {
                if (this.welcome.kioskResourceList[j].kiosk.rid == this.kioskListResource[i].rid) {
                  for (let k = 0; k < this.checkList.length; k++) {
                    if (this.checkList[k].kiosk.rid == this.kioskListResource[i].rid) {
                      this.checkList[k].check = true;
                      this.arrayToSend.push(this.checkList[k]);
                    }
                  }
                }
              }
            }
          }
          this.dateNow = new Date();
        },
        error => this.errorMessage = <any>error);
  }

  changeListenerMainImage($event): void {
    console.log("FFEFFF: ", $event)
    var file: File = $event.target.files[0];
    var myReader: FileReader = new FileReader();
    var image = this.element.nativeElement.querySelector('#documentInput');
    if ((file.type.slice(0, 9) === "image/jpg") || (file.type.slice(0, 9) === "image/JPG") ||
      (file.type.slice(0, 10) === "image/jpeg") || (file.type.slice(0, 10) === "image/JPEG") ||
      (file.type.slice(0, 9) === "image/png") || (file.type.slice(0, 9) === "image/PNG") ||
      (file.type.slice(0, 9) === "image/gif") || (file.type.slice(0, 9) === "image/GIF")) {
      if (file.size < 1000000) {
        myReader.onloadend = (e: any) => {
          image.src = e.target.result;
          console.log("eddddddddddddddd", image);
          this.welcome.imageString = e.target.result;
        }
        myReader.readAsDataURL(file);
      } else {
        forkJoin(
          [this.translate.get('Image error'),
          this.translate.get('Image size is more than 1 mb!')]
        ).subscribe((res) => {
          this._notificationService.create(res[0], res[1], 'error')
        })
      }
    } else {
      forkJoin(
        [this.translate.get('Image error'),
        this.translate.get('Only these formats of image are allowed: JPG, JPEG, PNG, GIF!')]
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      })
    }
  }

  edit() {
    this.saveErrors = true;
    let errors = false;
    if (!this.validationForm.valid) {
      forkJoin(
        [this.translate.get('Mising fields'),
        this.translate.get('Please fill out the fields on all languages!')]
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      });
      errors = true;
    }
    if (!this.welcome.imageString && !this.welcome.image) {
      forkJoin(
        [this.translate.get('Mising image'),
        this.translate.get('Please upload the image')]
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      });
      errors = true;
    }
    if (this.arrayToSend.length == 0) {
      forkJoin(
        this.translate.get('Mising fields'),
        this.translate.get('Please check at least 1 kiosk!')
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      });
      errors = true;
    }
    if (errors) {
      return
    }
    (!this.welcomeRid) && (this.welcome.userEmail = this.userEmail);
    this.welcome.kioskResourceList = this.arrayToSend;

    this.welcome.userEmail = this.userEmail;
    this.service.add(`/admin/welcome/edit`, this.welcome)
      .subscribe(
        response => {
          this.welcome = response;
          if ([11060, 11061, 11062, 11063, 11064].indexOf(this.welcome.errorCode) >= 0) {
            forkJoin(
              [this.translate.get('ADD/EDIT Error'),
              this.translate.get('The changes were not saved')]
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'error')
            });
          } else {
            // this.getWelcomeSection(this.welcomeRid);
            // var image = this.element.nativeElement.querySelector('#documentInput');
            // image.src = "";
            forkJoin(
              [this.translate.get('Success'),
              this.translate.get('Welcome section was successfully created!')]
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'success')
            });
            this.router.navigate(['/welcome-list/' ]);
          }
        },
        error => this.errorMessage = <any>error);
  }

  showResponsiveDetails(kioskId) {
		const width = window.innerWidth;
		if (width <= 1100) {
			for (let i = 0; i < this.kiosksList.list.length; i++) {
				if (this.kiosksList.list[i].rid == kioskId) {
					this.kiosksList.list[i].showDetailsOnResponsive = !this.kiosksList.list[i].showDetailsOnResponsive;
				}
				else {
					this.kiosksList.list[i].showDetailsOnResponsive = false;
				}
			}
		}
		else{
			return;
		}

	}
}
